// const url = 'https://script.google.com/macros/s/AKfycbw8KQNRok_ZpRW4w5KeW2AFOc9jri2ipQCmexHflaTR2dB024v3NcMg1AwtKPXlhIiYLg/exec';
const url = 'https://script.google.com/macros/s/AKfycbxXbeLYp0dtwQ0CJF_rB_d1_q68GLCCl4CvECk7UjIwDxAX9BXMJcKxFtjPRj7ElOLl/exec';
import axios from 'axios';
export const googleRepository =  {
    methods: {
        getAll(){
            return  axios.get(url);
        },
        update(json){
            var postparam = 
                {
                  "method"     : "POST",
                  "Content-Type" : "application/json",
                  "body" : JSON.stringify(json)
                };
         
          return fetch(url, postparam, {redirect: 'follow'});
        },
    }
}